export { default as CashOutlineIcon } from './CashOutlineIcon';
